import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Flex,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

import { hasMShop } from 'Helpers/ecommerce'

import { utilsState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/results'

const CannotCreateMessage: FC = () => {
  const intl = useIntl()

  const { canCreate } = useRecoilValue(utilsState)

  const goToMShop = hasMShop()

  const handleUpgradeClick = (): void => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_redirector.aspx?t=mshopem',
    ])
  }

  if (canCreate) {
    return null
  }

  return (
    <MessageBox
      variant={MESSAGE_BOX_VARIANT_HELP}
      title={intl.formatMessage({
        id: 'Load.TriggersList.TitleAlertCreateTriggerLimit',
      })}
    >
      {goToMShop ? (
        <Flex columnGap="4px">
          {intl.formatMessage({
            id: 'Load.TriggersList.AlertCreateTriggerLimitFirst',
          })}

          <Link variant={LINK_VARIANT_HIGHLIGHT} onClick={handleUpgradeClick}>
            {intl.formatMessage({
              id: 'Load.TriggersList.UpgradePlanNew',
            })}
          </Link>

          {intl.formatMessage({
            id: 'Load.TriggersList.AlertCreateTriggerLimitSecond',
          })}
        </Flex>
      ) : (
        <>
          {intl.formatMessage({
            id: 'Load.TriggersList.AlertCreateTriggerLimitWL',
          })}
        </>
      )}
    </MessageBox>
  )
}

export default CannotCreateMessage
